import { useContext, useEffect } from 'react';

import { cn } from '@/lib/cn';
import { PostMessageAction, sendMessage } from '@/lib/postMessage';

import { ThemeContext } from '../globals/ThemeProvider';
import Ai from '../icons/Ai';

type MessageProps = {
  children: React.ReactNode;
  type?: 'answer' | 'question' | 'ai' | 'error';
};

const Message = ({ children, type = 'answer' }: MessageProps) => {
  const { theme } = useContext(ThemeContext);
  useEffect(() => {
    if (type === 'error') {
      sendMessage(PostMessageAction.ERROR, { message: children?.toString() || 'Unknown error' });
    }
  }, [children, type]);

  return (
    <div
      className={cn('rounded-medium mb-2 w-fit max-w-4/5 p-4 font-normal', {
        'my-4 ml-auto rounded-br-none bg-blue-50 text-blue-900 dark:bg-yellow-950/65 dark:text-amber-500':
          type === 'answer',
        'text-content-negative mr-auto rounded-bl-none bg-neutral-900 dark:bg-neutral-100': type === 'question',
        'mr-auto rounded-bl-none border border-red-500 bg-rose-50 text-red-500 dark:bg-red-950/65': type === 'error',
        'border-ai-with-bg-neutral-900 text-content-negative mr-auto rounded-bl-none border-2 bg-red-500':
          type === 'ai',
        'border-ai-with-bg-neutral-100 text-content-negative mr-auto rounded-bl-none border-2 bg-red-500':
          type === 'ai' && theme === 'dark'
      })}
    >
      {type === 'ai' && <Ai className='mb-1 h-4 w-4' />}

      {children}
    </div>
  );
};

export default Message;
